import React from 'react';
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../../helper/BaseUrl';



export default function ComparisonDetalingBanner({ data }) {
  return (
    <>
      <section className='comparisondetalingbanner'>
        <img src="/assets/images/camparison-banner.webp" alt="Banner" className="img-responsive bg-img"/>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='media-detail-breadcrumb'>
                <ul className='dynamic-breadcrumb'>
                  <li><Link to={"/"}>Home</Link></li>
                  <li><Link to={"/comparison"}>Comparison</Link></li>
                  <li>{data?.title?.slice(0,20) + "..."}</li>
                </ul>
              </div>

              <h1 className='heading'>{data?.title}</h1>
                <p>{data?.short_description}</p>
            </div>
            <div className='col-lg-12'>
              <div className='comparison-detail-banner-img'>
                 <img src={BaseUrl + data?.hero_image} className="img-responsive" alt={data?.title} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
